module.exports = __webpack_public_path__ + "cd6b69df0eba6807ac44b5519ecb0409.svg";